/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospectsdescription2Inputs */

const en_coinvestments_prospectsdescription2 = /** @type {(inputs: Coinvestments_Prospectsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your organisation list for this deal. Import from Salesforce or upload a CSV file using our templates. Select prospects to approve before setting permissions.`)
};

/**
* | output |
* | --- |
* | "Build your organisation list for this deal. Import from Salesforce or upload a CSV file using our templates. Select prospects to approve before setting permi..." |
*
* @param {Coinvestments_Prospectsdescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospectsdescription2 = /** @type {((inputs?: Coinvestments_Prospectsdescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospectsdescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospectsdescription2(inputs)
});
export { coinvestments_prospectsdescription2 as "coInvestments_prospectsDescription" }